import React, { useMemo, useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form-new';
import { useTranslation } from 'react-i18next';

import { MIN_NAME_TRAINING_CENTER_LENGTH } from './constants';
import { StudyCenterState } from '../store/store';
import { actions } from '../store/actions';
import { Button, Checkbox, TextInput } from 'components';

interface FormProps {
    onSubmit: (value: StudyCenterFormData) => void;
    goBack: () => void;
}

export interface StudyCenterFormData {
    name: string;
    canCreateCertificate: boolean;
}

type StudyCenterFormProps = StudyCenterState & typeof actions & FormProps;

export const StudyCenterForm = (props: StudyCenterFormProps) => {
    const { goBack, onSubmit, editableStudyCenter } = props;
    const methods = useForm<StudyCenterFormData>({
        defaultValues: useMemo(() => editableStudyCenter, [editableStudyCenter]),
    });
    const { t } = useTranslation('validation');

    const { register, handleSubmit, formState, reset } = methods;
    const { isSubmitting, errors } = formState;

    useEffect(() => {
        reset(editableStudyCenter);
    }, [editableStudyCenter]);

    return (
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                <div className="form-group">
                    <TextInput
                        id="name"
                        label="Название"
                        type="text"
                        reg={register('name', {
                            minLength: {
                                value: MIN_NAME_TRAINING_CENTER_LENGTH,
                                message: t('validation:min-length', {
                                    minLength: MIN_NAME_TRAINING_CENTER_LENGTH,
                                }),
                            },
                            maxLength: {
                                value: 200,
                                message: t('validation:max-length', {
                                    maxLength: 200,
                                }),
                            },
                            required: {
                                value: true,
                                message: t('validation:required-field'),
                            },
                        })}
                        errorMessage={errors.name?.message as string}
                    />
                </div>
                <div className="form-group">
                    <Checkbox
                        id="isPartner"
                        reg={register('canCreateCertificate')}
                        label="Может выписывать сертификаты"
                    />
                </div>
                <div className="top-space-3x">
                    <Button buttonClass="primary" type="submit" isDisabled={isSubmitting}>
                        Сохранить
                    </Button>
                    <Button handleClick={goBack} buttonClass="secondary">
                        Отмена
                    </Button>
                </div>
            </form>
        </FormProvider>
    );
};
